import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fetchAuthSession } from 'aws-amplify/auth';
import { useNavigate } from "react-router-dom";
import "./search.scss"

export const Search = () => {
    const [userToken, setUserToken] = useState(null);
    const [queryName, setQueryName] = useState("");
    const [searchText, setSearchText] = useState("");
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    
    // Fetch User Token on mount
    const getUserToken = async () => {
        try {
            const session = await fetchAuthSession();
            const access_token = session.tokens.accessToken.toString();
            setUserToken(access_token);
        } catch (err) {
            console.error("Failed to get user token:", err);
            // redirect to login if needed
        }
    };

    useEffect(() => {
        getUserToken();
    }, []);

    const handleSearch = async () => {
        if (!queryName) {
            alert("Query name is required!");
            return;
        }
        if (!userToken) {
            alert("User token not available yet");
            return;
        }

        setLoading(true);

        try {
            const response = await fetch("https://api.weathervaneintel.com/api/api/search", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    userToken,
                    queryName,
                    searchText,
                    date: selectedDate.toISOString().split("T")[0]
                })
            });

            if (response.status === 403) {
                // Redirect unauthorized user to login
                navigate("/login");
                return; // stop further execution
            }

            if (!response.ok) {
                console.warn("Search API error:", response.status, response.statusText);
                setResults([]);
                return;
            }

            const data = await response.json();
            setResults(data); // update results only on success

        } catch (err) {
            console.error("Search API failed:", err);
            setResults([]);
        } finally {
            setLoading(false);
        }
    };

    // Highlight matching search terms in comment
    const highlightComment = (comment, searchTerms) => {
        if (!searchTerms) return comment;

        // Regex to match quoted phrases or single words
        const tokenPattern = /"([^"]+)"|\(([^)]+)\)|(\S+)/g;
        let tokens = [];
        let match;

        while ((match = tokenPattern.exec(searchTerms)) !== null) {
            if (match[1]) tokens.push(match[1]);        // Quoted phrase
            else if (match[2]) tokens.push(...match[2].split(/\s+OR\s+/i)); // Parenthesis group
            else if (!["AND", "OR"].includes(match[3].toUpperCase())) tokens.push(match[3]); // Single word
        }

        // Escape for regex
        const escapedTokens = tokens.map(t => t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
        if (escapedTokens.length === 0) return comment;

        // Build regex to match any token, case-insensitive
        const regex = new RegExp(`(${escapedTokens.join("|")})`, "gi");

        // Split and wrap matches in <span>
        const parts = comment.split(regex);

        return parts.map((part, idx) =>
            regex.test(part) ? (
                <span key={idx} className="highlight">{part}</span>
            ) : (
                part
            )
        );
    };

    return (
        <div className="search-page">
            <header>
                <h1>Threat Search Page</h1>
            </header>

            <div className="search-form">
                <input type="text" placeholder="Query Name (required)" value={queryName} onChange={(e) => setQueryName(e.target.value)} />
                <input type="text" placeholder="Search Text" value={searchText} onChange={(e) => setSearchText(e.target.value)} />
                <DatePicker selected={selectedDate} onChange={(date) => setSelectedDate(date)} dateFormat="yyyy-MM-dd" />
                <button onClick={handleSearch}>Search</button>
            </div>

            {loading ? (
                <p>Loading results...</p>
            ) : results.length === 0 ? (
                <p>No results found.</p>
            ) : (
                <div className="table-container">
                    <table className="results-table">
                        <colgroup>
                            <col style={{ width: "70%" }} />
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "15%" }} />
                        </colgroup>
                        <thead>
                            <tr>
                                <th>Comment</th>
                                <th>Link</th>
                                <th>Username</th>
                                <th>Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            {results.map((item, idx) => (
                                <tr key={idx}>
                                    <td>{highlightComment(item.comment, searchText)}</td>
                                    <td>
                                        <a href={item.link} target="_blank" rel="noopener noreferrer">
                                            View
                                        </a>
                                    </td>
                                    <td>{item.username}</td>
                                    <td>{item.timestamp}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
